"use client";

import { memo } from "react";
import { Box, HStack, VStack, Text } from "@chakra-ui/react";
import type { AtsJobDetails } from "../types";
import { SectionTitle } from "./SectionTitle";

export interface ExperienceSectionProps {
  experiences: AtsJobDetails["experiences"];
}

export const ExperienceSection = memo<ExperienceSectionProps>(
  ({ experiences }) => {
    if (!experiences || experiences.length === 0) return null;

    return (
      <Box as="section" aria-label="Experience" mb={6}>
        <SectionTitle title="Experience" />
        <VStack align="stretch" gap={4}>
          {experiences.map((exp, index) => (
            <Box key={`${exp.company}-${exp.title}-${index}`}>
              <HStack
                justify="space-between"
                align="flex-start"
                mb={1}
                wrap="wrap"
              >
                <VStack align="start" gap={0} flex={1}>
                  <Text
                    textStyle="sm"
                    fontWeight="bold"
                    color="neutral.900"
                    lineHeight="1.5"
                  >
                    {exp.title}
                  </Text>
                  <Text textStyle="sm" color="neutral.500" lineHeight="1.5">
                    {exp.company}
                  </Text>
                </VStack>
                <Text
                  textStyle="sm"
                  color="neutral.500"
                  whiteSpace="nowrap"
                  textAlign="right"
                >
                  {exp.start_date} - {exp.end_date}
                </Text>
              </HStack>
              {exp.responsibilities && exp.responsibilities.length > 0 && (
                <Box as="ul" listStyleType="disc" pl={5} mt={2} mb={0}>
                  {exp.responsibilities.map((resp, idx) => (
                    <Text
                      key={idx}
                      as="li"
                      textStyle="sm"
                      color="neutral.500"
                      lineHeight="1.6"
                      mb={0.5}
                    >
                      {resp}
                    </Text>
                  ))}
                </Box>
              )}
            </Box>
          ))}
        </VStack>
      </Box>
    );
  },
);
ExperienceSection.displayName = "ExperienceSection";
